import React from "react";

/* DropIcon — single source of truth for the in-app "drop / credit" symbol.
   Renders a filled-droplet SVG that respects current text color via
   `currentColor`, so callers can theme it with plain CSS (color, opacity,
   filter) or pass an explicit `color` prop. Width and height come from
   the `size` prop (px), defaulting to 1em so the icon scales with the
   surrounding font-size if no size is given. Any other valid SVG attribute
   (className, style, role, aria-*, etc.) is forwarded to the root <svg>. */
const DropIcon = ({ size, color = "currentColor", title, ...rest }) => {
  const dimension = size != null ? size : "1em";
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={dimension}
      height={dimension}
      viewBox="0 0 16 16"
      fill={color}
      aria-hidden={title ? undefined : "true"}
      role={title ? "img" : undefined}
      {...rest}
    >
      {title ? <title>{title}</title> : null}
      <path d="M8 16a6 6 0 0 0 6-6c0-1.655-1.122-2.904-2.432-4.362C10.254 4.176 8.75 2.503 8 0c0 0-6 5.686-6 10a6 6 0 0 0 6 6ZM6.646 4.646l.708.708c-.29.29-1.128 1.311-1.907 2.87l-.894-.448c.82-1.641 1.717-2.753 2.093-3.13Z" />
    </svg>
  );
};

export default DropIcon;

/* Backwards-compat named export — earlier code imported `DropletFill`
   from this file. Both names point at the same component now so any
   existing imports keep working without code changes. */
export const DropletFill = DropIcon;
